import { FC, useState } from "react";
import { SearchField } from "../../../components/forms/SearchField";
import ReactDOM from "react-dom";
import { SlideOutWrapper } from "./SlideOutWrapper";
export const SectionHeader: FC<{
  departmentChange: Function;
  locationChange: Function;
  departments: string[];
  locations: string[];
  selectedDepartment: string;
  selectedLocation: string;
  setQuery: Function;
}> = (props) => {
  const [openControl, setOpenControls] = useState(false);

  return (
    <div
      id="allPositions"
      className="sticky flex flex-col items-center gap-2 py-4 space-y-4 bg-white border-b md:flex-row md:align-center md:space-y-0 md:justify-between top-14"
    >
      <div className="col-span-1">
        <h2 className="text-2xl font-semibold text-center text-gray-800 lg:text-left ">
          Open Positions
        </h2>
      </div>
      <div className="col-span-1 col-start-3 col-end-3">
        <div className="flex items-center gap-2 mx-auto">
          <SearchField
            placeholder="Search for Roles"
            setQuery={props.setQuery}
          />
          {/* <button
            className="p-1 border rounded-sm shadow-sm text-primary-700 hover:bg-gray-50"
            onClick={() => setOpenControls(true)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5"
              />
            </svg>
          </button> */}

          {ReactDOM.createPortal(
            <SlideOutWrapper
              openControl={openControl}
              closeControl={setOpenControls}
            >
              <>
                <div className="p-4 font-semibold sm:px-6 bg-gradient-to-r from-gray-100 to-gray-200">
                  Filters
                </div>
                <div className="px-4 mt-4 space-y-6">
                  {/* <Dropdown
                    label="Departments"
                    items={props.departments}
                    setValue={props.departmentChange}
                    defaultValue={props.selectedDepartment}
                  />
                  <Dropdown
                    label="Locations"
                    items={props.locations}
                    setValue={props.locationChange}
                    defaultValue={props.selectedLocation}
                  /> */}
                </div>
              </>
            </SlideOutWrapper>,
            document.getElementById("modal-root")!
          )}
        </div>
        {/* <p className="mt-1 text-xs text-gray-500">
          All locations | All Departments
        </p> */}
      </div>
    </div>
  );
};
